// import { ArrowCircleRight } from "../../../svgIcons"

import { LinkField } from "../../index"

const bgColors = {
  whiteOnPink: "bg-primary text-white",
  whiteOnBlue: "bg-pink text-white",
  blackOnLightBlue: "bg-bgmain text-secondary",
}

export const AudienceCards = ({ cards }) => {
  return (
    cards &&
    cards?.length > 0 && (
      <section className="mx-4 -mt-16 antialiased lg:mx-auto">
        <div className="grid grid-cols-1 mx-4 md:gap-10 lg:gap-24 md:mx-0 md:grid-cols-2">
          {cards?.map(
            ({
              uid,
              title,
              audienceColorScheme,
              audienceDescription,
              audienceCtaLink,
              svgIcon,
            }) => (
              <LinkField key={uid} {...audienceCtaLink}>
                <article
                  className={`${bgColors[audienceColorScheme]} max-w-md pb-8 mx-auto  duration-500 transform bg-center bg-cover rounded-lg shadow-lg cursor-pointer group hover:-translate-y-1`}
                >
                  <header>
                    <h2 className="px-12 mt-8 text-3xl font-bold text-left min-h-18">
                      <div className="flex py-10">
                        <img
                          src={svgIcon[0]?.url}
                          className="w-12 h-12"
                          alt={title}
                        />
                      </div>
                      {title}
                    </h2>
                    <div
                      className="px-8 m-4 text-base leading-6 text-left text-md"
                      dangerouslySetInnerHTML={{ __html: audienceDescription }}
                    />
                  </header>
                  <footer className="justify-end px-10 mt-5 text-right ">
                    {/* <ArrowCircleRight className="w-8 h-8 text-white justify-self-end" /> */}
                  </footer>
                </article>
              </LinkField>
            )
          )}
        </div>
      </section>
    )
  )
}
